export function frameList(json) {
    return Object.values(json.frames);
}
export function getAnimationFrames(json, name) {
    var tag = json.meta.frameTags.find(function (t) { return t.name === name; });
    if (!tag)
        return [];
    var allFrames = frameList(json);
    return allFrames.slice(tag.from, tag.to);
}
//# sourceMappingURL=aseprite.js.map